// Utility to play product video
// Accepts a variant object as argument
import { BREAK_MOBILE } from '../config/constants';
import addClass from './dom/addClass';
import removeClass from './dom/removeClass';

const ON = 'on';

const playVideo = (variant) => {
  const isMobile = window.innerWidth < BREAK_MOBILE;
  const type = 'desktop';
  const media = document.querySelector('.product-media-video');

  if (!media) {
    console.warn('No product media video element found.');
    return;
  }

  const player = media.querySelector('.video-player-video');
  const loader = document.querySelector('.video-player-loader');
  const oldVideo = document.querySelector(`.product-media-video.${ON}`);
  const { backgroundVideo, backgroundVideoMobile } = variant.media;
  const videoSrc = isMobile && backgroundVideoMobile ? backgroundVideoMobile : backgroundVideo;
  const currentSource = player.querySelector('video source');
  const sourcesExist = !!currentSource && !!videoSrc;

  const videoSrcElement = document.createElement('div');
  videoSrcElement.innerHTML = videoSrc;
  const newVideoSource = videoSrcElement.querySelector('video source');
  const newSrc = newVideoSource ? newVideoSource.getAttribute('src') : null;

  const needsUpdate = !currentSource || (sourcesExist && currentSource.getAttribute('src') !== newSrc);
  const id = variant.video;
  const videos = window.HMR?.videos || false;
  const still = document.querySelector('.product-media-still');

  if (!needsUpdate) {
    return;
  }

  if (oldVideo) {
    oldVideo.querySelector('video').pause();
    removeClass(oldVideo, ON);
  }

  if (!videos && !still) {
    return;
  }

  if (still) {
    addClass(still, ON);
  }

  if (variant.media.backgroundVideo) {
    const { backgroundVideo, backgroundVideoMobile } = variant.media;
    const videoSrc = isMobile && backgroundVideoMobile ? backgroundVideoMobile : backgroundVideo;
    player.innerHTML = videoSrc;
  } else {
    if (videos.length === 0) {
      removeClass(media, ON);
      return;
    }

    let data = null;
    data = videos[`${id}-${type}`];

    if (!data) {
      const key = Object.keys(videos).find((key) => key.includes(type));
      data = videos[key];
    }

    if (!data) {
      removeClass(media, ON);
      return;
    }

    if (data.mobile) {
      addClass(media, 'mobile');
    } else {
      removeClass(media, 'mobile');
    }
    if (data.noImage) {
      addClass(media, 'no-image');
    } else {
      removeClass(media, 'no-image');
    }

    // Check the actual video sources are different before updating
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = data.video;
    const newVideoSource = tempDiv.querySelector('video source');
    const currentVideo = player.querySelector('video');
    const currentSource = currentVideo ? currentVideo.querySelector('source') : null;
    const newSrc = newVideoSource ? newVideoSource.getAttribute('src') : null;
    const currentSrc = currentSource ? currentSource.getAttribute('src') : null;

    if (currentSrc !== newSrc) {
      player.innerHTML = data.video;
    }
  }

  const video = player.querySelector('video');

  if (video) {
    const diff = window.innerWidth < BREAK_MOBILE ? 28 : 160;
    const width = window.innerWidth - diff;

    if (still) {
      removeClass(media, ON);
    }
    removeClass(loader, 'off');
    addClass(media, ON);

    video.muted = true;
    video.loop = true;
    video.autoplay = true;

    video.addEventListener('canplaythrough', () => {
      addClass(loader, 'off');
      setTimeout(async () => {
        video.querySelector('img').style.display = 'none';
        try {
          await video.play();
          video.pause();
          await video.play();
        } catch (exc) {
          console.info(exc);
        }
      }, 150);
    });
    video.width = width;
    video.load();
  }
  // Sound logic
  let audio = document.querySelector('.product-media-audio');
  if (!audio) {
    audio = document.createElement('audio');
    audio.setAttribute('preload', 'auto');
    audio.setAttribute('loop', 'true');
    audio.setAttribute(
      'src',
      'https://cdn.shopify.com/s/files/1/0036/5500/8323/files/Fantasy_Is_Reality.mp3?v=1746705105',
    );
    audio.setAttribute('controls', 'true');
    audio.setAttribute('aria-hidden', 'true');
    audio.setAttribute('class', 'product-media-audio');
    audio.setAttribute('hidden', 'true');
    audio.setAttribute('playsinline', 'true');
    audio.muted = true;
    document.body.appendChild(audio);
    audio.load();
  }

  const sound = document.querySelector('.product-media-unmute');
  if (sound && audio) {
    // Remove previous event listeners to avoid stacking
    sound.replaceWith(sound.cloneNode(true));
    const newSound = document.querySelector('.product-media-unmute');
    newSound.addEventListener('click', () => {
      const target = newSound.parentElement.querySelector('video');
      // target.volume = 0.75;
      if (target) target.volume = 0;
      audio.muted = !audio.muted;

      // Toggle audio playback
      if (audio.muted) {
        if (!audio.paused) {
          audio.pause();
        }
        [...document.querySelectorAll('.product-media-mute-icon')].forEach((icon) => {
          removeClass(icon, ON);
        });
        [...document.querySelectorAll('.product-media-unmute-icon')].forEach((icon) => {
          addClass(icon, ON);
        });
      } else {
        audio.muted = false;
        audio.volume = 0.75;
        audio.play().catch((err) => console.error('Audio playback failed:', err));
        [...document.querySelectorAll('.product-media-mute-icon')].forEach((icon) => {
          addClass(icon, ON);
        });
        [...document.querySelectorAll('.product-media-unmute-icon')].forEach((icon) => {
          removeClass(icon, ON);
        });
      }
    });
  }
};

export default playVideo;
